import { render, staticRenderFns } from "./RevaluationHistory.vue?vue&type=template&id=da001360&scoped=true"
import script from "./RevaluationHistory.vue?vue&type=script&lang=ts"
export * from "./RevaluationHistory.vue?vue&type=script&lang=ts"
import style0 from "./RevaluationHistory.vue?vue&type=style&index=0&id=da001360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da001360",
  null
  
)

export default component.exports